module.exports = __webpack_public_path__ + "media/images/fallback/desk_photo/home_default-b20e711eaddf41b9b27dfa47444c1e2d.png";